import React from 'react';
import './About.css';

function About() {
  const handleContactClick = () => {
  window.location.href = '/contato';
};

  return (
    <div className="about-page">
      <div className="container">
        {/* Header da página */}
        <div className="about-header">
          <span className="badge">✦ Quem somos</span>
          <h1>Sobre a <span className="hero-gradient">Survows</span></h1>
          <p>Transformamos ideias em soluções digitais de alta performance</p>
        </div>

        {/* Diferencial principal - Pagamento após finalização */}
        <div className="payment-guarantee">
          <div className="payment-card">
            <div className="payment-icon">
              <i className="fas fa-hand-holding-usd"></i>
            </div>
            <h2>Pagamento somente após finalizar o seu projeto</h2>
            <p>
              Você só paga quando o projeto estiver 100% concluído e aprovado por você. 
              Sem surpresas, sem parcelas antecipadas. Nossa prioridade é sua satisfação e confiança.
            </p>
            <div className="payment-badge">
              <i className="fas fa-check-circle"></i> 100% seguro e transparente
            </div>
          </div>
        </div>

        {/* Como trabalhamos */}
        <div className="how-we-work">
          <h2 className="section-title">como <span className="hero-gradient">trabalhamos</span></h2>
          <div className="work-steps">
            <div className="step-card">
              <div className="step-number">01</div>
              <div className="step-icon">
                <i className="fas fa-comments"></i>
              </div>
              <h3>Briefing e análise</h3>
              <p>Entendemos sua necessidade, objetivo e público-alvo. Alinhamos expectativas e definimos escopo.</p>
            </div>

            <div className="step-card">
              <div className="step-number">02</div>
              <div className="step-icon">
                <i className="fas fa-paintbrush"></i>
              </div>
              <h3>Design e protótipo</h3>
              <p>Criamos o layout, identidade visual e navegação. Você valida antes de qualquer código.</p>
            </div>

            <div className="step-card">
              <div className="step-number">03</div>
              <div className="step-icon">
                <i className="fas fa-code"></i>
              </div>
              <h3>Desenvolvimento</h3>
              <p>Código limpo, responsivo e otimizado. Utilizamos as melhores tecnologias do mercado.</p>
            </div>

            <div className="step-card">
              <div className="step-number">04</div>
              <div className="step-icon">
                <i className="fas fa-rocket"></i>
              </div>
              <h3>Entrega e deploy</h3>
              <p>Projeto finalizado, testado e publicado. Você só paga após aprovação final.</p>
            </div>
          </div>
        </div>

        {/* Equipe rápida e objetiva */}
        <div className="team-section">
          <div className="team-content">
            <div className="team-text">
              <span className="badge">✦ Nossa equipe</span>
              <h2>Rápida, objetiva e <br /><span className="hero-gradient">resultados reais</span></h2>
              <p>
                Não enrolamos. Nossa equipe é formada por especialistas que entregam valor desde o primeiro contato.
                Comunicação direta, prazos realistas e compromisso com a excelência.
              </p>
              <ul className="team-list">
                <li><i className="fas fa-bolt"></i> Resposta em até 24h</li>
                <li><i className="fas fa-chart-line"></i> Metodologia ágil</li>
                <li><i className="fas fa-users"></i> Atendimento personalizado</li>
                <li><i className="fas fa-shield-alt"></i> Suporte pós-entrega</li>
              </ul>
            </div>
            <div className="team-stats">
              <div className="stat-card">
                <span className="stat-number">50+</span>
                <span className="stat-label">Projetos entregues</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">100%</span>
                <span className="stat-label">Clientes satisfeitos</span>
              </div>
              <div className="stat-card">
                <span className="stat-number">24h</span>
                <span className="stat-label">Resposta média</span>
              </div>
            </div>
          </div>
        </div>

        {/* Valores / Diferenciais */}
        <div className="values-section">
          <div className="value-card">
            <i className="fas fa-gem"></i>
            <h3>Qualidade garantida</h3>
            <p>Código limpo, testado e com as melhores práticas do mercado.</p>
          </div>
          <div className="value-card">
            <i className="fas fa-clock"></i>
            <h3>Entregas no prazo</h3>
            <p>Cronograma transparente e cumprimento de prazos acordados.</p>
          </div>
          <div className="value-card">
            <i className="fas fa-headset"></i>
            <h3>Suporte contínuo</h3>
            <p>Acompanhamento mesmo após a entrega do projeto.</p>
          </div>
          <div className="value-card">
            <i className="fas fa-lock"></i>
            <h3>Segurança total</h3>
            <p>Seus dados e seu projeto protegidos com os melhores padrões.</p>
          </div>
        </div>

        {/* Call to Action - COM ESTILO CORRETO */}
        <div className="about-cta">
          <h3>Vamos criar algo incrível juntos?</h3>
          <button className="btn-primary" onClick={handleContactClick}>
            Solicitar serviço <i className="fas fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default About;
